'use strict';
var Log = require('./index');
module.exports = Log.Log;
